import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2cd5f8c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "channelEdit-container"
};
const _hoisted_2 = {
  key: 0,
  class: "dialog-footer"
};
import { computed, ref, onMounted } from 'vue';
import { getSysDictListApi } from '@/api/live';
import { liveStore } from '@/store/liveStore';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'channelEdit',
  props: {
    dialogObject: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['dialogClose', 'dialogSuccess'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const sysDictList = ref([]);
    const transferProtocolObj = ref([]);
    const broadcastTypeObj = ref([]);
    const loading = ref(true);
    const formTableRef = ref(null); // 分发策略选项统一走 liveStore（带缓存，父组件已拉取则直接复用，不重复请求）

    const store = liveStore();
    const {
      distributionStrategyOptions
    } = storeToRefs(store); // 获取编码协议列表

    const getSysDictList = async type => {
      loading.value = true;
      const {
        code,
        data
      } = await getSysDictListApi(type);

      if (code === '0') {
        switch (type) {
          case 'code_protocol':
            sysDictList.value = data;
            break;

          case 'broadcast_type':
            broadcastTypeObj.value = data;
            break;

          case 'transfer_protocol':
            transferProtocolObj.value = data ? data.filter(item => item.value !== 4) : [];
            break;
        }

        loading.value = false;
      }
    };

    onMounted(() => {
      getSysDictList('code_protocol');
      getSysDictList('broadcast_type');
      getSysDictList('transfer_protocol');
      loading.value = false;
    });
    const activeAction = [{
      value: 0,
      label: '是'
    }, {
      value: 1,
      label: '否'
    }]; // 处理props的数据 重新定义 dialogVisible

    const dialogShow = computed({
      get() {
        return props.dialogObject.dialogVisible;
      },

      set(val) {
        return val;
      }

    });
    const obj = {
      dialogTitle: props.dialogObject.title || '标题',
      dialogWidth: props.dialogObject.width || '30%',
      dialogCloseBtnText: props.dialogObject.closeBtnText || '取消',
      dialogSuccessBtnText: props.dialogObject.successBtnText || '确定',
      dialogIsFooter: props.dialogObject.isFooter || false
    };

    const close = () => {
      emit('dialogClose', false, 'close');
    };

    const validName = (rule, value, callback) => {
      if (!value) return callback(new Error(t('请输入频道源名称')));
      if (value.length > 255) return callback(new Error(t('频道源名称的长度应在1到255字符之间')));
      callback();
    }; // 新增编辑model


    const actionForm = reactive({
      visible: false,
      // 预览图片路径
      imgUrl: '',
      formList: [[// { label: '频道源名称', prop: 'name', widgetType: 'input', rules:{required: true, validator:validName, trigger: 'blur'} }, 
      {
        label: '激活状态',
        prop: 'state',
        widgetType: 'Select',
        translation: true,
        list: activeAction
      }, {
        label: '分辨率',
        prop: 'broadcastType',
        widgetType: 'Select',
        list: broadcastTypeObj,
        rules: {
          required: true,
          message: t('请选择分辨率'),
          trigger: 'change'
        }
      }], [{
        label: '传输协议',
        prop: 'transferProtocol',
        widgetType: 'Select',
        list: transferProtocolObj,
        rules: {
          required: true,
          message: t('请选择传输协议'),
          trigger: 'change'
        }
      }, {
        label: '编码标准',
        prop: 'programType',
        widgetType: 'Select',
        list: sysDictList,
        rules: {
          required: true,
          message: t('请选择编码标准'),
          trigger: 'change'
        }
      }], [{
        label: '分发策略',
        prop: 'distributionStrategy',
        widgetType: 'Select',
        filterable: true,
        list: distributionStrategyOptions,
        rules: {
          required: true,
          message: t('请选择分发策略'),
          trigger: 'change'
        }
      }, {
        label: '频道URL',
        prop: 'channelURL',
        widgetType: 'input',
        rules: {
          required: true,
          message: t('请输入频道URL'),
          trigger: 'blur'
        }
      }], [{
        label: 'Http Headers',
        prop: 'httpHeaders',
        widgetType: 'input',
        required: false
      }]],
      // formData是双向绑定的值
      formData: (() => {
        const row = { ...props.dialogObject.row
        }; // formList的prop与这里的key对应，此处为初始化数据，注意要浅拷贝
        // 分发策略无值时默认选中「不限」

        if (!row.distributionStrategy) row.distributionStrategy = 'default';
        return row;
      })(),
      dialogConfig: {
        title: '新增'
      },
      confirm: async () => {
        await formTableRef.value.mForm.validate((valid, fields) => {
          if (valid) {
            // //校验添加项与当前物理频道列表是否有编码标准、传输协议、分辨率相同的项
            // const {physicalChannels} = JSON.parse(JSON.stringify(props.dialogObject.data))
            // //已有的物理频道和新添加的物理频道
            // physicalChannels.splice(props.dialogObject.index,1,actionForm.formData) //当前编辑的频道替换掉原来的频道
            // // channelKeys: 是由每一项编码标准-传输协议-分辨率 构成的数组 ['1-1-12'、'1-2-12']
            // const channelKeys = physicalChannels.map(item=> {
            //   return item.programType + '-' + item.transferProtocol + '-' + item.broadcastType
            // })
            // //去重
            // let uniqueChannelKeys = Array.from(new Set(channelKeys))
            // // 去重后数组长度与原数组一致，则新添加的没有重复
            // if(uniqueChannelKeys.length===channelKeys.length) {
            //   //新添加的频道编码标准、传输协议、分辨率没有一样的
            //   emit('dialogSuccess', actionForm.formData, props.dialogObject.index)
            // } else {
            //   //有编码标准、传输协议、分辨率一样的频道
            //   return ElMessage({type:'error', message: t('请勿重复添加编码标准、传输协议、分辨率一样的频道')})
            // }
            // 去掉编码标准、传输协议、分辨率相同的校验，如有需要直接使用上述代码
            emit('dialogSuccess', actionForm.formData, props.dialogObject.index);
          } else {
            return console.log('error submit!', fields);
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogShow),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogShow) ? dialogShow.value = $event : null),
        title: _ctx.$t(obj.dialogTitle),
        width: obj.dialogWidth,
        "before-close": close,
        draggable: ""
      }, {
        footer: _withCtx(() => [obj.dialogIsFooter ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createVNode(_component_el_button, {
          class: "btn-mixins-clear-default",
          onClick: close
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(obj.dialogCloseBtnText)), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "btn-mixins dia-suc",
          type: "primary",
          onClick: actionForm.confirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(obj.dialogSuccessBtnText)), 1)]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          "form-list": actionForm.formList,
          "form-data": actionForm.formData,
          ref_key: "formTableRef",
          ref: formTableRef
        }, null, 8, ["form-list", "form-data"])]),
        _: 1
      }, 8, ["modelValue", "title", "width"])), [[_directive_loading, loading.value]])]);
    };
  }

});